import React, { useState } from "react";
import Icon from "components/AppIcon";
import Button from "components/ui/Button";
import Input from "components/ui/Input";

const UserProfile = ({ user, onSave }) => {
  const [editing, setEditing] = useState(false);
  const [changingPassword, setChangingPassword] = useState(false);
  const [form, setForm] = useState({
    nombre: user?.nombre,
    correo: user?.correo,
    telefono: user?.telefono,
  });
  const [passwordForm, setPasswordForm] = useState({ actual: "", nueva: "", confirmar: "" });
  const [errors, setErrors] = useState({});
  const [pwErrors, setPwErrors] = useState({});
  const [saved, setSaved] = useState(false);

  const handleChange = (e) => setForm({ ...form, [e?.target?.name]: e?.target?.value });
  const handlePwChange = (e) => setPasswordForm({ ...passwordForm, [e?.target?.name]: e?.target?.value });

  const handleSave = () => {
    const newErrors = {};
    if (!form?.nombre?.trim()) newErrors.nombre = "El nombre es requerido";
    if (!form?.correo?.trim()) newErrors.correo = "El correo es requerido";
    if (Object.keys(newErrors)?.length > 0) { setErrors(newErrors); return; }
    setErrors({});
    onSave(form);
    setEditing(false);
    setSaved(true);
    setTimeout(() => setSaved(false), 3000);
  };

  const handlePasswordSave = () => {
    const newErrors = {};
    if (!passwordForm?.actual) newErrors.actual = "Ingrese su contraseña actual";
    if (passwordForm?.nueva?.length < 8) newErrors.nueva = "Mínimo 8 caracteres";
    if (passwordForm?.nueva !== passwordForm?.confirmar) newErrors.confirmar = "Las contraseñas no coinciden";
    if (Object.keys(newErrors)?.length > 0) { setPwErrors(newErrors); return; }
    setPwErrors({});
    setChangingPassword(false);
    setPasswordForm({ actual: "", nueva: "", confirmar: "" });
  };

  return (
    <div className="rounded-xl border bg-white" style={{ borderColor: "var(--color-border)", boxShadow: "var(--shadow-sm)" }}>
      <div className="p-4 md:p-5 border-b flex items-center justify-between" style={{ borderColor: "var(--color-border)" }}>
        <div className="flex items-center gap-2">
          <Icon name="User" size={18} color="var(--color-primary)" />
          <h2 className="font-semibold text-sm md:text-base" style={{ fontFamily: "var(--font-heading)", color: "var(--color-foreground)" }}>
            Mi Perfil
          </h2>
        </div>
        {saved && (
          <span className="text-xs flex items-center gap-1" style={{ color: "var(--color-success)" }}>
            <Icon name="CheckCircle" size={14} color="var(--color-success)" /> Guardado
          </span>
        )}
      </div>
      <div className="p-4 md:p-5 space-y-4">
        {/* Org info */}
        <div className="rounded-lg p-3 flex flex-col gap-1" style={{ backgroundColor: "var(--color-muted)" }}>
          <p className="text-xs font-semibold uppercase tracking-wide" style={{ color: "var(--color-muted-foreground)", fontFamily: "var(--font-caption)" }}>
            Organización
          </p>
          <p className="text-sm font-medium" style={{ color: "var(--color-foreground)" }}>{user?.organizacion}</p>
          <p className="text-xs" style={{ color: "var(--color-muted-foreground)" }}>NIT: {user?.nit}</p>
          <p className="text-xs" style={{ color: "var(--color-muted-foreground)" }}>Ciudad: {user?.ciudad}</p>
        </div>

        {!editing ? (
          <div className="space-y-3">
            {[
              { label: "Nombre completo", value: user?.nombre, icon: "User" },
              { label: "Correo electrónico", value: user?.correo, icon: "Mail" },
              { label: "Teléfono", value: user?.telefono, icon: "Phone" },
              { label: "Rol", value: "Usuario Cliente", icon: "Shield" },
            ]?.map((item) => (
              <div key={item?.label} className="flex items-center gap-3">
                <div className="w-8 h-8 rounded-lg flex items-center justify-center flex-shrink-0" style={{ backgroundColor: "var(--color-muted)" }}>
                  <Icon name={item?.icon} size={14} color="var(--color-muted-foreground)" />
                </div>
                <div>
                  <p className="text-xs" style={{ color: "var(--color-muted-foreground)", fontFamily: "var(--font-caption)" }}>{item?.label}</p>
                  <p className="text-sm font-medium" style={{ color: "var(--color-foreground)" }}>{item?.value}</p>
                </div>
              </div>
            ))}
            <div className="flex gap-2 pt-2">
              <Button variant="outline" size="sm" iconName="Edit" iconPosition="left" onClick={() => setEditing(true)}>
                Editar perfil
              </Button>
              <Button variant="ghost" size="sm" iconName="Lock" iconPosition="left" onClick={() => setChangingPassword(!changingPassword)}>
                Cambiar contraseña
              </Button>
            </div>
          </div>
        ) : (
          <div className="space-y-3">
            <Input label="Nombre completo" name="nombre" value={form?.nombre} onChange={handleChange} error={errors?.nombre} required />
            <Input label="Correo electrónico" type="email" name="correo" value={form?.correo} onChange={handleChange} error={errors?.correo} required />
            <Input label="Teléfono" type="tel" name="telefono" value={form?.telefono} onChange={handleChange} placeholder="+57 300 000 0000" />
            <div className="flex gap-2">
              <Button variant="default" size="sm" onClick={handleSave}>Guardar</Button>
              <Button variant="ghost" size="sm" onClick={() => { setEditing(false); setErrors({}); }}>Cancelar</Button>
            </div>
          </div>
        )}

        {changingPassword && (
          <div className="border-t pt-4 space-y-3" style={{ borderColor: "var(--color-border)" }}>
            <p className="text-sm font-semibold" style={{ fontFamily: "var(--font-heading)", color: "var(--color-foreground)" }}>Cambiar contraseña</p>
            <Input label="Contraseña actual" type="password" name="actual" value={passwordForm?.actual} onChange={handlePwChange} error={pwErrors?.actual} required />
            <Input label="Nueva contraseña" type="password" name="nueva" value={passwordForm?.nueva} onChange={handlePwChange} error={pwErrors?.nueva} required />
            <Input label="Confirmar nueva contraseña" type="password" name="confirmar" value={passwordForm?.confirmar} onChange={handlePwChange} error={pwErrors?.confirmar} required />
            <div className="flex gap-2">
              <Button variant="default" size="sm" onClick={handlePasswordSave}>Actualizar</Button>
              <Button variant="ghost" size="sm" onClick={() => { setChangingPassword(false); setPwErrors({}); }}>Cancelar</Button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default UserProfile;